import { render, staticRenderFns } from "./ShaftRow.vue?vue&type=template&id=3f52fc80&scoped=true&"
import script from "./ShaftRow.vue?vue&type=script&lang=js&"
export * from "./ShaftRow.vue?vue&type=script&lang=js&"
import style0 from "./ShaftRow.vue?vue&type=style&index=0&id=3f52fc80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f52fc80",
  null
  
)

export default component.exports